import type { OperationCompletionEffect } from './types'

const effects = new Map<string, OperationCompletionEffect>()

export function registerOperationCompletionEffect(
  operationType: string,
  effect: OperationCompletionEffect,
) {
  effects.set(operationType, effect)
}

export function getOperationCompletionEffect(
  operationType: string,
): OperationCompletionEffect | undefined {
  return effects.get(operationType)
}
